export default "__VITE_ASSET__ddej5BH7__"